import { FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FilterTable, { BaseData } from './Table/Table';
import EventDTO, { EventPublicStatus } from '../models/event';
import EmptyTable from './Table/EmptyTable';
import { setSelectedEvent } from '../store/slices/events';

interface EventTableProps {
  events: EventDTO[];
}

interface EventTableRow extends BaseData {
  status: JSX.Element;
  name: string;
  business: string;
  business_id: string;
}

const EventsTable: React.FC<EventTableProps> = ({ events }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const config = [
    {
      id: 'status',
      label: 'Estado',
    },
    {
      id: 'name',
      label: 'Nombre',
    },
    {
      id: 'business',
      label: 'Productora',
    },
  ];

  const onEyeClick = (row: EventTableRow) => {
    const event = events.find((e) => e.id === row.id);
    if (event) {
      dispatch(setSelectedEvent(event));
      navigate(`/admin/${row.business_id}/events/${row.id}`);
    }
  };

  const actions = (row: EventTableRow) => (
    <div className='flex items-center justify-center'>
        <img src="/eye.svg" alt="" onClick={() => onEyeClick(row)} className='cursor-pointer'/>
      </div>
  );

  const statusLabel = (event: EventDTO) => {
    if (event.public_status === EventPublicStatus.PendingApproval) {
      return <p className='tag-warning'>Pendiente</p>;
    }
    if (event.public_status === EventPublicStatus.Ready && new Date(event.created_at) > new Date(new Date().setDate(new Date().getDate() - 5))) {
      return <p className='tag-primary'>Nuevo</p>;
    }
    if (event.public_status === EventPublicStatus.Ready && new Date(event.updated_at) > new Date(new Date().setDate(new Date().getDate() - 5))) {
      return <p className='tag-secondary'>Aprobado</p>;
    }
    return <p className='tag-neutral'>Desconocido</p>;
  };

  const rows: EventTableRow[] = events.map((event) => ({
    id: event.id,
    status: statusLabel(event),
    name: event.name,
    business: event.business_name,
    business_id: event.business_id,
  }));

  return (
    <div>
      {rows.length > 0 ? (
        <FilterTable
          rows={rows}
          headCells={config}
          actions={actions}
          tableId="events-table"
        />
      ) : (
        <EmptyTable
          title="No hay eventos pendientes"
          info="No hay eventos pendientes"
          icon={FaExclamationTriangle}
          iconColor="text-secondary-500"
        />
      )}
    </div>
  );
};

export default EventsTable;
